import Head from 'next/head';
import { useRouter } from 'next/router';

const BASE_URL = 'https://cphsecuritywait.dk';

// Emits a self-referencing canonical plus bidirectional hreflang alternates
// (da, en, x-default) for the current route. Rendered globally from _app so
// every page gets correct international SEO signals in the server HTML.
//
// With Next.js i18n routing, `da` is the default locale (served without a
// prefix) and `en` is served under /en. `router.asPath` excludes the locale
// prefix, so we build the localized URLs from it.
export default function SeoAlternates() {
    const router = useRouter();

    // Strip query string / hash so the canonical is clean and stable.
    const path = (router.asPath || '/').split('?')[0].split('#')[0];

    const localized = (locale) => {
        const prefix = locale === 'da' ? '' : `/${locale}`;
        if (path === '/') {
            return locale === 'da' ? `${BASE_URL}/` : `${BASE_URL}${prefix}`;
        }
        return `${BASE_URL}${prefix}${path}`;
    };

    const daUrl = localized('da');
    const enUrl = localized('en');
    const canonical = router.locale === 'en' ? enUrl : daUrl;

    return (
        <Head>
            <link rel="canonical" href={canonical} />
            <link rel="alternate" hrefLang="da" href={daUrl} />
            <link rel="alternate" hrefLang="en" href={enUrl} />
            <link rel="alternate" hrefLang="x-default" href={daUrl} />
        </Head>
    );
}
